export default {
  namespaced: true,

  state: {
    types: [],
    payable_costs: [],
    payment_methods: []
  },

  mutations: {
    retrieveTypes(state) {
      if (!state.types.length) {
        window.Ajax.get('/penalties/types')
          .then(response => {
            state.types = response.data;
          })
          .catch(err => {});
      }
    },

    retrievePayableCosts(state) {
      if (!state.payable_costs.length) {
        window.Ajax.get('/penalties/payable-costs')
          .then(response => {
            state.payable_costs = response.data;
          })
          .catch(err => {});
      }
    },

    retrievePaymentMethods(state) {
      if (!state.payment_methods.length) {
        window.Ajax.get('/penalties/payment-methods')
          .then(response => {
            state.payment_methods = response.data;
          })
          .catch(err => {});
      }
    }
  },

  getters: {
    types(state) {
      return state.types;
    },

    payableCosts(state) {
      return state.payable_costs;
    },

    paymentMethods(state) {
      return state.payment_methods;
    }
  }
};
